module.exports = __webpack_public_path__ + "img/ESL-Kenneth-Barnes-Savannah-Spring-2015-SK_3_SN.249286f2.webp";